import { z } from "zod";
import { defineEvent } from "./registry.js";
/**
 * Cari kartın ticari şartları değişti (limit, blokaj, etkinlik). İstasyon ajanı limit özeti önbelleğini bu olayla
 * tazeler. Yük kişisel veri TAŞIMAZ; ayrıntı yetki denetimli API'den çekilir.
 */
export const counterpartyChangedV1 = defineEvent({
    type: "counterparty.changed",
    version: 1,
    description: "Cari kart oluşturuldu ya da ticari şartları (limit, blokaj, etkinlik) değişti",
    realtime: ["tenant"],
    payload: z.object({
        counterpartyId: z.uuid(),
        change: z.enum(["CREATED", "UPDATED", "BLOCKED", "UNBLOCKED", "LIMIT_CHANGED"]),
    }),
});
export const counterpartyTransactionPostedV1 = defineEvent({
    type: "counterparty.transaction.posted",
    version: 1,
    description: "Cari hareketi (tahsilat, ödeme, dekont, virman, açılış) kaydedildi",
    realtime: ["tenant"],
    payload: z.object({
        transactionId: z.uuid(),
        companyId: z.uuid(),
        counterpartyId: z.uuid(),
        txnType: z.string(),
        amount: z.string(),
        documentDate: z.iso.date(),
        ledgerStatus: z.enum(["POSTED", "QUEUED", "NONE"]),
    }),
});
export const counterpartyTransactionCancelledV1 = defineEvent({
    type: "counterparty.transaction.cancelled",
    version: 1,
    description: "Cari hareketi iptal edildi (ters kayıt alındı, açık kalemleri iptal oldu)",
    realtime: ["tenant"],
    payload: z.object({
        transactionId: z.uuid(),
        companyId: z.uuid(),
        counterpartyId: z.uuid(),
    }),
});
export const counterpartyAllocationChangedV1 = defineEvent({
    type: "counterparty.allocation.changed",
    version: 1,
    description: "Açık kalem eşleştirmesi yapıldı ya da geri alındı",
    realtime: ["tenant"],
    payload: z.object({
        companyId: z.uuid(),
        counterpartyId: z.uuid(),
        change: z.enum(["ALLOCATED", "REVERSED"]),
        allocationIds: z.array(z.uuid()),
        totalAmount: z.string(),
    }),
});
/** ALARM: alt defter (açık kalemler) ana defterle uyuşmuyor. Ana defter gerçeğin kaynağıdır. */
export const counterpartyLedgerMismatchV1 = defineEvent({
    type: "counterparty.ledger_mismatch.detected",
    version: 1,
    description: "Cari alt defteri ile ana defter kontrol hesabı arasında fark bulundu",
    realtime: ["tenant"],
    payload: z.object({
        runId: z.uuid(),
        companyId: z.uuid(),
        diffCount: z.number().int(),
        totalAbsoluteDifference: z.string(),
    }),
});
//# sourceMappingURL=counterparties.v1.js.map